import { COURSE_CATEGORY_PATHS } from '../common/public-courses.mjs'

// 레거시 메인(https://techedu.kr/main/, kiraedu main/index.php)의 블록을 그대로 옮긴 홈 화면 정본 자료다.
// - 메인 비주얼: nynMainImage(orderBy 순) 4건. 레거시 링크는 새 사이트의 같은 메뉴 경로로 바꾼다.
// - 이달의 교육/추천과정/신규과정: nynContents ⨝ nynCategory(division 964/965/966, enabled='Y', orderBy 순) 2026-10-15 스냅숏.
//   같은 목록은 공통코드 LEGACY.month/recomm/new(LEGACY_MAIN)에 레거시 contentsCode로 남아 있으므로 code 값을 그대로 둔다.
//   카드는 레거시 sort02 분류에 해당하는 과정 메뉴로 가서 ?code=로 같은 과정 상세를 연다(CourseCatalogPage, 레거시 /lecture/?seq=).
// - 아이콘 바·오프라인 교육 배너·계좌 정보는 레거시도 정적 문안이다. 이미지는 public/images/main/ 에 복사했다.
const SORT_PATHS = Object.fromEntries(Object.entries(COURSE_CATEGORY_PATHS).map(([path, category]) => [category, path]))

export const HOME_VISUALS = [
  { image: '/images/main/visual-fraud.png', to: '/guide/fraud-prevention', alt: '테크에듀, 당신의 경쟁력을 JUMP UP!! 부정훈련 NO! 올바른 직업훈련 YES! 같이 채우는 훈련 문화…가치 높이는 우리 미래', label: '부정훈련방지안내 보기', background: '#3b3838' },
  { image: '/images/main/visual-techedu.jpg', to: SORT_PATHS.lecture0405, alt: '테크에듀, 당신의 경쟁력을 JUMP UP!! 테크에듀 TECH EDU. 사업주환급교육의 새로운 지평… 테크에듀가 제공하는 지식과 기술의 결합', label: '직무역량 과정 보기', background: '#3332d8' },
  { image: '/images/main/visual-safety.jpg', to: SORT_PATHS.lecture0301, alt: '테크에듀, 당신의 경쟁력을 JUMP UP!! 산업안전보건교육. 산업 현장의 위험 관리, 테크에듀에게 맡기세요. 현장 근로자에서 관리감독자까지…기업 맞춤형 커리큘럼 제공', label: '산업안전 근로자 과정 보기', background: '#5d6670' },
  { image: '/images/main/visual-legal.png', to: SORT_PATHS.lecture0101, alt: '테크에듀, 당신의 경쟁력을 JUMP UP!! 5대 법정의무교육. 건강한 직장문화 조성을 위한 커리큘럼. 더 나은 우리 직장 만들기, 테크에듀가 도와드립니다', label: '공통법정의무교육 과정 보기', background: '#222222' },
]

// 카드 문안은 레거시와 같다: 총차시 N 차시 / 학습시간 N 시간 / 교육비 N원(천 단위 쉼표).
const course = (code, title, chapters, hours, price, sort02) => ({ key: code, title, to: `${SORT_PATHS[sort02]}?code=${code}`, image: `/images/main/courses/${code}.jpg`,
  rows: [['총차시', `${chapters} 차시`], ['학습시간', `${hours} 시간`], ['교육비', `${price.toLocaleString('ko-KR')}원`]] })

export const HOME_COURSES = {
  month: [
    course('867U6V', '[표창원의 안전 프로파일링] 제조업 현장근로자 정기안전보건교육 (상반기)', 12, 12, 60000, 'lecture0301'),
    course('6CACJF', '[표창원의 안전 프로파일링] 기타업 현장근로자 정기안전보건교육 (상반기)', 12, 12, 60000, 'lecture0301'),
    course('1B1YVF', '[관리감독자 서비스업 및 기타업 집체교육_5월29일] 기타업종 및 서비스업종 관리감독자 집체 교육...5월29일 개강', 0, 8, 100000, 'lecture0302'),
    course('VV0PB6', '[관리감독자 제조업 집체교육_5월26일] 제조업종 관리감독자 집체 교육...5월26일 개강', 0, 8, 100000, 'lecture0302'),
    course('NBJQQ0', '[관리감독자 제조업 집체교육_5월11일] 제조업종 관리감독자 집체 교육...5월11일 개강', 0, 8, 100000, 'lecture0302'),
  ],
  recommend: [
    course('YRITF1', '일잘러들의 업무파트너, ChatGPT 스마트하게 일하라!', 20, 21, 87780, 'lecture0405'),
    course('FUZZ16', '고객만족을 위한 7가지 성공 가이드', 30, 31, 129580, 'lecture0405'),
    course('PW3393', '무조건 팔리는 세일즈 퍼포먼스 스킬', 30, 31, 129580, 'lecture0405'),
    course('R2ASWX', '인공지능 시대! 디지털 비즈니스 플랫폼에서 살아남기(30차시 ver)', 30, 31, 4180, 'lecture0405'),
    course('YYW1V0', '회사를 살리는 유튜브&인스타그램 소셜 미디어 마케팅', 30, 31, 4180, 'lecture0405'),
    course('L9Q105', '의료기관 종사자가 알아야 할 의료기술 트렌드', 30, 31, 4180, 'lecture0405'),
  ],
  fresh: [
    course('47DIZ7', 'Chat GPT를 활용한 컴맹도 쉬운 AI', 27, 28, 4180, 'lecture0405'),
    course('6YUJ26', '실전에 필요한 내용만 모았다! ChatGPT&AI 툴 활용 가이드', 20, 21, 4180, 'lecture0405'),
    course('DBUMTH', '갑자기 비서가 생겼다! 나만의 AI인턴 활용법', 19, 20, 4180, 'lecture0405'),
    course('F6DM3F', 'AI시대, 똑똑한 사람은 어떻게 생각하고 질문하는가', 19, 20, 4180, 'lecture0405'),
    course('OWRQ4K', '[AI 김현욱 아나운서] 10분이면 따라하는 직장인 ChatGPT 바이블', 30, 31, 4180, 'lecture0405'),
    course('EBQUSY', '제조 보안 문제 분석과 해법 : IEC 62443 분석 및 구축 전략 집중 분석', 33, 34, 300000, 'lecture0401'),
  ],
}

// 외부 채널(뉴스·카카오채널·유튜브·블로그)은 레거시와 같은 주소를 새 창으로 연다(카카오채널은 레거시 http 주소의 https판). 내부 게시판은 새 메뉴 경로다.
// 내부 경로(to)는 포털 설정에서 해당 메뉴를 숨기면 홈에서도 보이지 않는다(PortalHomePage가 portal.visiblePath로 거른다).
export const HOME_ICON_LINKS = [
  { title: '뉴스', href: 'https://www.hellot.net', image: '/images/main/icon-news.png' },
  { title: '카카오채널', href: 'https://pf.kakao.com/_uxiQxiG', image: '/images/main/icon-cacao.png' },
  { title: '유튜브', href: 'https://tinyurl.com/2xqc6mdp', image: '/images/main/icon-youtube.png' },
  { title: '블로그', href: 'https://blog.naver.com/chomdan_', image: '/images/main/icon-blog.png' },
  { title: 'Q&A', to: '/support/qna', image: '/images/main/icon-qna.png' },
  { title: '자료실', to: '/support/library', image: '/images/main/icon-file.png' },
  { title: '부정훈련예방', to: '/guide/fraud-prevention', image: '/images/main/icon-not.png' },
]

export const HOME_OFFLINE = [
  { title: '오프라인 교육 안내', href: 'https://he.step.or.kr/main.do', image: '/images/main/offline-guide.png' },
  { title: '오프라인 교육 시설', to: '/guide/usage', image: '/images/main/offline-facility.png' },
  { title: '오프라인 교육 일정', href: 'https://tinyurl.com/294mnbw3', image: '/images/main/offline-schedule.png' },
]

// 레거시 고객센터 블록의 고정 문안. 전화·운영시간은 게시된 포털 설정이 있으면 그것을 우선한다.
export const HOME_CUSTOMER = { phone: '02-3142-4151', email: 'eduinfo@hellot.net', hours: ['월~금요일 : 09:00 ~ 18:00', '점심시간 : 12:00 ~13:00', '주말, 공휴일 휴무'] }
export const HOME_ACCOUNT = { bank: '국민은행 : (주)첨단', number: '계좌번호 : 479001-01-050359' }
